import React from 'react';
import {useParams} from 'react-router-dom';

const CurrentOrgIdPrefix = React.createContext<string | null>(null);

/**
 * Reads :currentOrgIdPrefix off the URL and puts it in context for the page
 * below. Child orgs are addressed by this slug, so pages can't build their own
 * URLs without it.
 */
export function WithOrgIdPrefix({children}: {children: React.ReactNode}) {
  const {currentOrgIdPrefix} = useParams();
  return (
    <CurrentOrgIdPrefix.Provider value={currentOrgIdPrefix ?? null}>
      {children}
    </CurrentOrgIdPrefix.Provider>
  );
}

export const useCurrentOrgIdPrefix = (raiseError: boolean = true) => {
  const currentOrgIdPrefix = React.useContext(CurrentOrgIdPrefix);
  // NOTE: Normally we want to throw an error like the one below if
  // this is used out of context. However we are using this in WithLoggedInAuth
  // where this isn't guaranteed to have a value. Be careful!
  if (raiseError && !currentOrgIdPrefix) {
    throw new Error('CurrentOrgIdPrefix context not found');
  }
  return currentOrgIdPrefix;
};
